import {
  getElement,
  store,
} from '@wordpress/interactivity';

const savedItemsNumber = 3;
const savedItemsName = 'recentSearches';


const {state} = store('instantSearch', {
  state: {
    matched_posts: [],
    matched_casinos: [],
    matched_slots: [],
    matched_all: [],
    hasAnyPosts: false,
    hasAnyCasinos: false,
    hasAnySuggestions: false,
    hasAnyResults: false,
    resultsPage: {
      'post': 1,
      'casino-online': 1,
      'slots': 1,
    },
    hideMoreResults: {
      'post': true,
      'casino-online': true,
      'slots': true,
    },
  },
  actions: {
    saveRecentSearchToLocalStorage() {
      const ref = getRefOrWarn();
      if (!ref) return;

      const searchPhrase = ref?.innerText?.trim();
      const searchUrl = ref?.href?.trim();

      if (!searchPhrase || !searchUrl) {
        return;
      }

      const recentItem = {
        post_title: searchPhrase,
        url: searchUrl,
      };

      let recentSearches = JSON.parse(localStorage.getItem(savedItemsName)) || [];

      if (recentSearches.some(item => item.post_title === searchPhrase)) {
        return;
      }

      recentSearches.unshift(recentItem);

      if (recentSearches.length > savedItemsNumber) {
        recentSearches.pop();
      }

      state.recent_searches = recentSearches;

      try {
        localStorage.setItem(savedItemsName, JSON.stringify(recentSearches));
      } catch (e) {
        console.error('Unable to save to localStorage:', e);
      }
    },
    hasAnyPosts() {
      return state.hasAnyPosts;
    },

    hasAnyCasinos() {
      return state.hasAnyCasinos && state.search.length > 0;
    },

    hasAnySlots() {
      return state.hasAnySlots && state.search.length > 0;
    },

    fetchMoreResults() {
      const ref = getRefOrWarn();
      if (!ref) return;

      const type = ref.getAttribute('type');
      const searchPhrase = state.search;

      if (!searchPhrase) {
        console.warn('Search phrase is empty.');
        return;
      }

      const pageIncrementation = 1;

      switch (type) {
        case 'post':
          state.resultsPage[type] += pageIncrementation;
          break;
        case 'casino-online':
          state.resultsPage[type] += pageIncrementation;
          break;
        case 'slots':
          state.resultsPage[type] += pageIncrementation;
          break;
        default:
          console.warn('Unknown post type.');
          return;
      }

      const url = `${WLC?.rest_settings?.url}/ia-search?search=${searchPhrase}&post_type=${type}&paged=${state.resultsPage[type]}&query_type=load_more`;

      fetch(url)
        .then(response => response.json())
        .then(data => {

          state.hideMoreResults[type] = data.total_results <= state.resultsPage[type] * 3;

          if (type === 'post') {
            state.matched_posts = [...state.matched_posts.map((post) => JSON.parse(JSON.stringify(post))), ...data.results];
          }
          if (type === 'casino-online') {
            state.matched_casinos = [...state.matched_casinos.map((post) => JSON.parse(JSON.stringify(post))), ...data.results];

          }
          if (type === 'slots') {
            state.matched_slots = [...state.matched_slots.map((post) => JSON.parse(JSON.stringify(post))), ...data.results];
          }

        })
        .catch(error => {
          console.error('Error:', error);
        });
     }
  },
  callbacks: {
    highlightSearchPhrase() {

      const ref = getRefOrWarn();
      if (!ref) return;

      const searchPhrase = state.search;
      const regex = new RegExp(searchPhrase, 'gi');
      const innerHTML = ref.innerHTML;

      ref.innerHTML = innerHTML.replace(regex, match => `<strong>${match}</strong>`);
    },

    generateRating() {
      const ref = getRefOrWarn();
      if (!ref) return;

      const postId = Number(ref.getAttribute('postid'));
      const postType = ref.dataset.posttype;

      if (postType === 'casino-online') {
        ref.innerHTML = state.matched_casinos.find(page => page.id === postId).rating ?? '';
      }
      if (postType === 'slots') {
        ref.innerHTML = state.matched_slots.find(page => page.id === postId).rating ?? '';
      }
    },

    addResultsClass() {
      const searchResultsModal = document.querySelector('.search-results-modal');
      const noResultsText = document.querySelector('.no-results-info');

      if (!searchResultsModal) {
        return;
      }

      if (state.hasAnyResults && state.search.length > 0) {
        searchResultsModal.classList.add('has-results');
        searchResultsModal.classList.remove('any-results', 'initial');
      } else if (!state.hasAnyResults && state.search.length === 0) {
        searchResultsModal.classList.add('initial');
        searchResultsModal.classList.remove('has-results', 'any-results');
      } else {
        searchResultsModal.classList.remove('has-results');
        searchResultsModal.classList.add('any-results');
        noResultsText.innerHTML = `No results found for "<strong>${state.search}</strong>"`;
      }
    },
    setAllResultsNumber() {
      const ref = getRefOrWarn();
      if (!ref) return;

      const type = ref.getAttribute('type');
      let results;

      switch (type) {
        case 'posts':
          results = state.totalPosts;
          break;
        case 'casinos':
          results = state.totalCasinos;
          break;
        case 'slots':
          results = state.totalSlots;
          break;
        default:
          console.warn(`Unknown type: ${type}`);
          return;
      }

      ref.innerHTML = `View all results (${results})`;
    }
  }
});

const getRefOrWarn = () => {
  const {ref} = getElement();
  if (!ref) {
    console.warn('Element reference is missing.');
  }
  return ref;
};

const handleSearchAgainButtonClick = () => {
  const searchAgainButton = document.querySelector('.search-again');
  const searchInput = document.querySelector('#instantSearch');

  if (!searchAgainButton) {
    return;
  }

  searchAgainButton.addEventListener('click', () => {
    state.search = '';

    const initialSearchResults = document.querySelectorAll('.search-results-listing');

    if (!initialSearchResults) return;

    initialSearchResults.forEach(resultContainer => {
      resultContainer.classList.remove('hidden');
    });

    searchInput.value = '';
    searchInput.focus();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  handleSearchAgainButtonClick();
});